/* Publish by EComposer at 2026-09-30 08:29:10*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-rlt2j4vvl7a"]=  window.__ectimmers["ecom-rlt2j4vvl7a"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-rlt2j4vvl7a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rlt2j4vvl7a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bpnbq21m7ue').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bpnbq21m7ue', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8jwj3fwf4q5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8jwj3fwf4q5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-102sg1vhtx4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-102sg1vhtx4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hbu7ikhre0l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hbu7ikhre0l', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-uoyhbtdcuyd"]=  window.__ectimmers["ecom-uoyhbtdcuyd"] || {};
const t=this.$el;if(!t||!this.isLive)return;const e=t.querySelector(".element__featured--wrapper-list");if(e){let i={top:0,left:0,x:0,y:0};const n=function(r){const a=r.clientX-i.x;e.scrollLeft=i.left-a},o=function(){e.removeEventListener("mousemove",n),e.removeEventListener("mouseup",o),e.style.cursor="default",e.style.removeProperty("user-select")},s=function(r){e.style.cursor="grabbing",e.style.userSelect="none",i={left:e.scrollLeft,top:e.scrollTop,x:r.clientX,y:r.clientY},e.addEventListener("mousemove",n),e.addEventListener("mouseup",o)};e.addEventListener("mousedown",s),e.addEventListener("mouseleave",o)}

                    });
                    
                        document.querySelectorAll('.ecom-uoyhbtdcuyd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uoyhbtdcuyd', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-03mhslj2wd29"]=  window.__ectimmers["ecom-03mhslj2wd29"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-03mhslj2wd29').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-03mhslj2wd29', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3v7tm1772m7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3v7tm1772m7', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}